export const overridingFundInfo = (visibleFunds, overrideFunds) => {
  return visibleFunds.map((originFund) => {
    const override = overrideFunds.find((fund) => fund.originalCode === originFund.code)
    if (override) {
      return override
    }
    return originFund
  })
}
